import { registerDefaultBlockRegistry } from './default-registry.js';
import { mediaGalleryBlock } from '../blocks/media-gallery/index.js';
import { titleBlock } from '../blocks/title/index.js';
import { ratingBlock } from '../blocks/rating/index.js';
import { priceBlock } from '../blocks/price/index.js';
import { variantPickerBlock } from '../blocks/variant-picker/index.js';
import { quantityBlock } from '../blocks/quantity/index.js';
import { buyButtonsBlock } from '../blocks/buy-buttons/index.js';
import { codFormBlock } from '../blocks/cod-form/index.js';
import { descriptionBlock } from '../blocks/description/index.js';
import { trustBlock } from '../blocks/trust/index.js';
import { collapsibleRowBlock } from '../blocks/collapsible-row/index.js';
import { textBlock } from '../blocks/text/index.js';
import { headingBlock } from '../blocks/heading/index.js';
import { imageBlock } from '../blocks/image/index.js';
import { buttonBlock } from '../blocks/button/index.js';
import { dividerBlock } from '../blocks/divider/index.js';
import { shippingCheckpointsBlock } from '../blocks/shipping-checkpoints/index.js';
import { urgencyBlock } from '../blocks/urgency/index.js';
import { urgencyBoxBlock } from '../blocks/urgency-box/index.js';
import { estimatedShippingBlock } from '../blocks/estimated-shipping/index.js';
import { inventoryBlock } from '../blocks/inventory/index.js';
import { paymentBadgesBlock } from '../blocks/payment-badges/index.js';
import { emojiBenefitsBlock } from '../blocks/emoji-benefits/index.js';
import { stickyAtcBlock } from '../blocks/sticky-atc/index.js';
import { skuBlock } from '../blocks/sku/index.js';
import { shareButtonBlock } from '../blocks/share-button/index.js';
import { viewDetailsBlock } from '../blocks/view-details/index.js';
import { sizingChartBlock } from '../blocks/sizing-chart/index.js';
import { tabsBlock } from '../blocks/tabs/index.js';
import { complementaryBlock } from '../blocks/complementary/index.js';
import { iconWithTextBlock } from '../blocks/icon-with-text/index.js';
import { iconWithContentBlock } from '../blocks/icon-with-content/index.js';
import { textWithIconBlock } from '../blocks/text-with-icon/index.js';
import { columnBlock } from '../blocks/column/index.js';
import { tabColumnBlock } from '../blocks/tab-column/index.js';
import { benefitPanelBlock } from '../blocks/benefit-panel/index.js';
import { benefitRowBlock } from '../blocks/benefit-row/index.js';
import { sizeRowBlock } from '../blocks/size-row/index.js';
import { offerCardBlock } from '../blocks/offer-card/index.js';
import { volumeTiersBlock } from '../blocks/volume-tiers/index.js';
import { reviewBlock } from '../blocks/review/index.js';
import { spacerBlock } from '../blocks/spacer/index.js';
import { welcomeFieldBlock } from '../blocks/welcome-field/index.js';
import { welcomeSubmitBlock } from '../blocks/welcome-submit/index.js';
import { welcomeConsentBlock } from '../blocks/welcome-consent/index.js';
export const defaultBlockRegistry = {
    [mediaGalleryBlock.type]: mediaGalleryBlock,
    [titleBlock.type]: titleBlock,
    [ratingBlock.type]: ratingBlock,
    [priceBlock.type]: priceBlock,
    [variantPickerBlock.type]: variantPickerBlock,
    [quantityBlock.type]: quantityBlock,
    [buyButtonsBlock.type]: buyButtonsBlock,
    [codFormBlock.type]: codFormBlock,
    [descriptionBlock.type]: descriptionBlock,
    [trustBlock.type]: trustBlock,
    [collapsibleRowBlock.type]: collapsibleRowBlock,
    [textBlock.type]: textBlock,
    [headingBlock.type]: headingBlock,
    [imageBlock.type]: imageBlock,
    [buttonBlock.type]: buttonBlock,
    [dividerBlock.type]: dividerBlock,
    // Shrine conversion product blocks (Tier 1A).
    [shippingCheckpointsBlock.type]: shippingCheckpointsBlock,
    [urgencyBlock.type]: urgencyBlock,
    [urgencyBoxBlock.type]: urgencyBoxBlock,
    [estimatedShippingBlock.type]: estimatedShippingBlock,
    [inventoryBlock.type]: inventoryBlock,
    [paymentBadgesBlock.type]: paymentBadgesBlock,
    [emojiBenefitsBlock.type]: emojiBenefitsBlock,
    [stickyAtcBlock.type]: stickyAtcBlock,
    // Shrine secondary product blocks (Tier 1A).
    [skuBlock.type]: skuBlock,
    [shareButtonBlock.type]: shareButtonBlock,
    [viewDetailsBlock.type]: viewDetailsBlock,
    [sizingChartBlock.type]: sizingChartBlock,
    [tabsBlock.type]: tabsBlock,
    [complementaryBlock.type]: complementaryBlock,
    // Shrine content blocks usable in the product info column (Tier 1B).
    [iconWithTextBlock.type]: iconWithTextBlock,
    [iconWithContentBlock.type]: iconWithContentBlock,
    [textWithIconBlock.type]: textWithIconBlock,
    // Shrine "Custom columns V2" layout container.
    [columnBlock.type]: columnBlock,
    // The uniform media card nested under a `tabbed-columns` tab.
    [tabColumnBlock.type]: tabColumnBlock,
    // Top-tier PDP buy-box anatomy blocks (Shokz-class reference).
    [benefitPanelBlock.type]: benefitPanelBlock,
    [benefitRowBlock.type]: benefitRowBlock,
    [sizeRowBlock.type]: sizeRowBlock,
    [offerCardBlock.type]: offerCardBlock,
    // Standalone bundle/volume selector (reuses OfferTiles outside cod-form).
    [volumeTiersBlock.type]: volumeTiersBlock,
    // Single customer review (avatar + stars + quote) for the buy-box.
    [reviewBlock.type]: reviewBlock,
    // Un vide réglable entre deux blocs — utilisable partout, né pour la fenêtre de bienvenue (0074).
    [spacerBlock.type]: spacerBlock,
    // Les pièces du FORMULAIRE de la fenêtre de bienvenue (0074 lot B) : un champ, le bouton qui envoie,
    // la mention de consentement. Elles ne rendent rien de vivant toutes seules — leur comportement vient
    // du contexte que l'îlot de la vitrine fournit (`blocks/_shared/welcomeForm`).
    [welcomeFieldBlock.type]: welcomeFieldBlock,
    [welcomeSubmitBlock.type]: welcomeSubmitBlock,
    [welcomeConsentBlock.type]: welcomeConsentBlock,
};
// Hand the assembled registry to the leaf holder BlockRenderer reads at render time. BlockRenderer
// cannot import this file directly without closing the cycle — see renderer/default-registry.ts.
registerDefaultBlockRegistry(defaultBlockRegistry);
//# sourceMappingURL=block-registry.gen.js.map